document.documentElement.classList.remove('no-js');
const $=(selector,context=document)=>context.querySelector(selector);
const $$=(selector,context=document)=>[...context.querySelectorAll(selector)];

function toggleLayer(element,open){
  if(!element)return;
  element.classList.toggle('is-open',open);
  element.setAttribute('aria-hidden',String(!open));
  document.body.classList.toggle('locked',open);
  if(open)setTimeout(()=>$('input,button,a',element)?.focus(),50);
}

document.addEventListener('click',event=>{
  const opener=event.target.closest('[data-open]');
  const closer=event.target.closest('[data-close]');
  const stickySubmit=event.target.closest('[data-sticky-submit]');
  if(opener){event.preventDefault();toggleLayer(document.getElementById(opener.dataset.open),true);}
  if(closer){event.preventDefault();toggleLayer(closer.closest('.drawer,.search-modal,.mobile-menu'),false);}
  if(stickySubmit){event.preventDefault();$('[data-product-form] [name="add"]')?.click();}
  const sizeGuideOpen=event.target.closest('[data-size-guide-open]');
  const sizeGuideClose=event.target.closest('[data-size-guide-close]');
  if(sizeGuideOpen){event.preventDefault();document.getElementById(sizeGuideOpen.dataset.sizeGuideOpen)?.showModal();}
  if(sizeGuideClose){event.preventDefault();sizeGuideClose.closest('dialog')?.close();}
});
document.addEventListener('keydown',event=>{if(event.key==='Escape')$$('.is-open').forEach(element=>toggleLayer(element,false));});

function initHeader(){
  const header=$('[data-header]');
  if(!header)return;
  const observe=()=>header.classList.toggle('is-sticky',header.dataset.sticky==='true'&&scrollY>40);
  addEventListener('scroll',observe,{passive:true});
  observe();
}

function updateOptionAvailability(form,variants,selected){
  $$('[data-option]',form).forEach(input=>{
    const index=Number(input.dataset.index);
    const possible=variants.some(variant=>variant.available&&variant.options.every((value,optionIndex)=>{
      if(optionIndex===index)return value===input.value;
      if(optionIndex<index)return selected[optionIndex]===value;
      return true;
    }));
    input.disabled=!possible;
    const label=form.querySelector(`label[for="${CSS.escape(input.id)}"]`);
    if(label)label.classList.toggle('is-unavailable',!possible);
  });
}

function syncProduct(form,{moveMedia=true}={}){
  if(form.hasAttribute('data-grouped-product-form')){
    syncGroupedProduct(form,{moveMedia});
    return;
  }
  const selected={};
  $$('[data-option]',form).forEach(input=>{if(input.checked)selected[input.dataset.index]=input.value;});
  const variants=JSON.parse($('[data-variants]',form)?.textContent||'[]');
  const variant=variants.find(item=>item.options.every((value,index)=>selected[index]===value));
  const variantSelect=$('[data-variant-select]',form);
  const button=$('[name="add"]',form);
  const error=$('[data-product-error]',form);
  updateOptionAvailability(form,variants,selected);
  if(error)error.hidden=true;
  if(!variant||!variantSelect){
    if(button){button.disabled=true;button.textContent=button.dataset.unavailable;}
    return;
  }
  variantSelect.value=String(variant.id);
  const selectedOption=variantSelect.options[variantSelect.selectedIndex];
  $$('[data-product-price],[data-sticky-price]').forEach(element=>{element.textContent=selectedOption.dataset.price;});
  button.disabled=!variant.available;
  button.textContent=variant.available?button.dataset.add:button.dataset.sold;
  replaceVariantUrl(variant.id);
  const mediaId=selectedOption.dataset.mediaId;
  if(moveMedia&&mediaId){
    const media=$(`[data-media-id="${CSS.escape(mediaId)}"]`,$('[data-product-root]'));
    $$('.product-media',$('[data-product-root]')).forEach(item=>item.classList.toggle('is-active',item===media));
    media?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
  }
}

function formatShopMoney(cents){
  const currency=window.Shopify?.currency?.active||'JPY';
  return new Intl.NumberFormat(document.documentElement.lang||'ja-JP',{style:'currency',currency,maximumFractionDigits:currency==='JPY'?0:2}).format(cents/100);
}

function replaceVariantUrl(variantId){
  const nextUrl=new URL(location.href);
  nextUrl.searchParams.set('variant',variantId);
  history.replaceState({},'',`${nextUrl.pathname}${nextUrl.search}`);
}

function syncGroupedProduct(form,{moveMedia=true}={}){
  const color=$('[data-colorway-option]:checked',form);
  const size=$('[data-grouped-size]:checked',form);
  const variants=JSON.parse($(`[data-colorway-variants="${CSS.escape(color?.value||'')}"]`,form)?.textContent||'[]');
  const variant=variants.find(item=>item.options.includes(size?.value));
  const variantInput=$('[data-variant-select]',form);
  const button=$('[name="add"]',form);
  const error=$('[data-product-error]',form);
  $$('[data-grouped-size]',form).forEach(input=>{
    const possible=variants.some(item=>item.available&&item.options.includes(input.value));
    input.disabled=!possible;
    form.querySelector(`label[for="${CSS.escape(input.id)}"]`)?.classList.toggle('is-unavailable',!possible);
  });
  if(error)error.hidden=true;
  if(!variant||!variantInput){
    if(button){button.disabled=true;button.textContent=button.dataset.unavailable;}
    return;
  }
  variantInput.value=String(variant.id);
  $$('[data-product-price],[data-sticky-price]').forEach(element=>{element.textContent=formatShopMoney(variant.price);});
  const selectedColor=$('[data-selected-color]',form);
  if(selectedColor)selectedColor.textContent=color.dataset.colorName;
  const lineColor=$('[data-line-color]',form);
  if(lineColor)lineColor.value=color.dataset.colorName;
  button.disabled=!variant.available;
  button.textContent=variant.available?button.dataset.add:button.dataset.sold;
  replaceVariantUrl(variant.id);
  const root=form.closest('[data-product-root]');
  $$('.product-gallery__set',root).forEach(set=>set.classList.toggle('is-active',set.dataset.colorwayGallery===color.value));
  const activeGallery=$('.product-gallery__set.is-active',root);
  const activeTrack=$('[data-gallery-track]',activeGallery);
  if(activeTrack){activeTrack.scrollLeft=0;updateGalleryCounter(activeTrack);}
  if(moveMedia)activeGallery?.scrollIntoView({behavior:'smooth',block:'nearest',inline:'start'});
}

function updateGalleryCounter(track){
  const slides=$$('[data-gallery-slide]',track);
  const counter=$('[data-gallery-current]',track.closest('.product-gallery__set'));
  if(!counter||!slides.length)return;
  const index=Math.min(slides.length-1,Math.max(0,Math.round(track.scrollLeft/Math.max(track.clientWidth,1))));
  counter.textContent=String(index+1).padStart(2,'0');
}

function initProductGalleries(scope=document){
  $$('[data-gallery-track]',scope).forEach(track=>{
    if(track.dataset.galleryInitialized)return;
    track.dataset.galleryInitialized='true';
    let frame;
    track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(()=>updateGalleryCounter(track));},{passive:true});
    updateGalleryCounter(track);
  });
}

function initProducts(scope=document){
  $$('[data-product-form]',scope).forEach(form=>{
    if(form.dataset.initialized)return;
    form.dataset.initialized='true';
    form.addEventListener('change',()=>syncProduct(form));
    syncProduct(form,{moveMedia:false});
  });
  const primary=$('[data-primary-atc]',scope),sticky=$('[data-sticky-atc]',scope);
  if(primary&&sticky){
    new IntersectionObserver(([entry])=>sticky.classList.toggle('is-visible',!entry.isIntersecting),{threshold:0}).observe(primary);
    const footer=$('.footer');
    if(footer)new IntersectionObserver(([entry])=>sticky.classList.toggle('is-near-footer',entry.isIntersecting),{threshold:0}).observe(footer);
  }
}

function initRelatedSelection(scope=document){
  $$('[data-related-selection]',scope).forEach(async section=>{
    if(section.dataset.loaded||!section.dataset.url)return;
    section.dataset.loaded='true';
    try{
      const html=await fetch(section.dataset.url).then(response=>response.text());
      const fragment=new DOMParser().parseFromString(html,'text/html');
      const fresh=$('[data-related-selection]',fragment);
      if(fresh?.innerHTML.trim())section.innerHTML=fresh.innerHTML;
    }catch(exception){console.error(exception);}
  });
}

function initReveals(scope=document){
  if(!document.body.classList.contains('motion-enabled'))return;
  const candidates=$$('.section-head,.brand-statement__text,.feature__content,.feature__media,.detail-grid>*,.editorial-banner__content,.philosophy>.rte,.newsletter>*,.product-card,.product-editorial__copy,.product-editorial__media,.product-fit__copy,.product-fit__media,.product-details-editorial__header,.product-details-editorial__row,.product-campaign-intro__inner,.product-editorial-image__frame,.product-landing-split__media,.product-landing-split__copy,.product-size-chart__header,.product-information-band__inner,.product-brand-finale__inner',scope);
  candidates.forEach(element=>element.setAttribute('data-reveal',''));
  const pending=$$('[data-reveal]:not(.is-revealed)',scope);
  if(!('IntersectionObserver' in window)){pending.forEach(element=>element.classList.add('is-revealed'));return;}
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(!entry.isIntersecting)return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  },{rootMargin:'0px 0px -8% 0px',threshold:.08});
  pending.forEach(element=>observer.observe(element));
}

document.addEventListener('submit',async event=>{
  const form=event.target.closest('[data-product-form]');
  if(!form)return;
  event.preventDefault();
  const button=$('[name="add"]',form),error=$('[data-product-error]',form);
  button.disabled=true;
  try{
    const response=await fetch(`${window.Shopify?.routes?.root||'/'}cart/add.js`,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
    const result=await response.json();
    if(!response.ok)throw new Error(result.description||result.message||`Cart add failed: ${response.status}`);
    await refreshCart();
    toggleLayer($('#CartDrawer'),true);
  }catch(exception){
    if(error){error.textContent=exception.message;error.hidden=false;}
    console.error(exception);
  }finally{syncProduct(form,{moveMedia:false});}
});

async function refreshCart(){
  const root=window.Shopify?.routes?.root||'/';
  const [sections,cart]=await Promise.all([fetch(`${root}?sections=cart-drawer`).then(response=>response.json()),fetch(`${root}cart.js`).then(response=>response.json())]);
  const documentFragment=new DOMParser().parseFromString(sections['cart-drawer'],'text/html');
  const fresh=$('#CartDrawer',documentFragment),current=$('#CartDrawer');
  if(fresh&&current)current.replaceWith(fresh);
  $$('[data-cart-count]').forEach(element=>{element.textContent=cart.item_count;});
}

document.addEventListener('change',async event=>{
  const input=event.target.closest('[data-cart-quantity]');
  if(!input)return;
  input.disabled=true;
  const root=window.Shopify?.routes?.root||'/';
  try{await fetch(`${root}cart/change.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({line:Number(input.dataset.line),quantity:Number(input.value)})});await refreshCart();toggleLayer($('#CartDrawer'),true);}catch(exception){console.error(exception);input.disabled=false;}
});

let searchTimer;
document.addEventListener('input',event=>{
  const searchInput=event.target.closest('[data-predictive-input]');
  if(!searchInput)return;
  clearTimeout(searchTimer);
  searchTimer=setTimeout(async()=>{
    const query=searchInput.value.trim(),output=$('[data-predictive-results]');
    if(query.length<2){output.innerHTML='';return;}
    const root=window.Shopify?.routes?.root||'/';
    const html=await fetch(`${root}search/suggest?q=${encodeURIComponent(query)}&section_id=predictive-search`).then(response=>response.text());
    const documentFragment=new DOMParser().parseFromString(html,'text/html');
    output.innerHTML=$('#shopify-section-predictive-search',documentFragment)?.innerHTML||'';
  },220);
});

initHeader();
initProducts();
initProductGalleries();
initRelatedSelection();
initReveals();
document.addEventListener('shopify:section:load',event=>{initProducts(event.target);initProductGalleries(event.target);initRelatedSelection(event.target);initReveals(event.target);});
